import { styled } from '@mui/system';
import { TextField, MenuItem } from '@mui/material';

const TextStyle = {
  fontFamily: 'Fjalla One',
  fontWeight: 400,
  fontSize: '18px',
  lineHeight: '22px',
};

const TextInputProps = {
  sx: {
    fontFamily: 'Fjalla One',
    fontWeight: 400,
    fontSize: '18px',
    lineHeight: '22px',
    color: '#000',
    '& .MuiInput-input': {
      paddingTop: '0',
    },
  },
};

const TextInputLabelProps = {
  sx: {
    color: 'rgba(153, 152, 154, 0.7)',
    fontFamily: 'Fjalla One',
    fontSize: '18px',
    fontWeight: 400,
    letterSpacing: '0em',
    textAlign: 'left',
    '&.MuiInputLabel-shrink': {
      color: '#717171',
      fontFamily: 'Raleway',
      fontSize: '16px',
      top: '6px',
      lineHeight: '16px',
    },
  },
};

const CafeInfoContainer = styled('div')({
  margin: '0',
  padding: '0',
});

const ErrorMessage = styled('div')({
  fontSize: '12px',
  color: 'red',
  height: '18px',
});

const ErrorMessageEmpty = styled('div')({
  height: '18px',
});

const CafeNameContainer = styled('div')({});

const CafeName = styled(TextField)({
  width: '350px',
  '>div::before': {
    borderBottom: '2px solid #AA9178',
  },
  '>div::after': {
    borderBottom: '2px solid #AA9178',
  },
});

const FlexContainer = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
});

const CafePhoneContainer = styled('div')({});

const CafePhone = styled(TextField)({
  width: '220px',
  '>div::before': {
    borderBottom: '2px solid #AA9178',
  },
  '>div::after': {
    borderBottom: '2px solid #AA9178',
  },
});

const PostcodeContainer = styled('div')({});

const Postcode = styled(TextField)({
  width: '100px',
  '>div::before': {
    borderBottom: '2px solid #AA9178',
  },
  '>div::after': {
    borderBottom: '2px solid #AA9178',
  },
});

const StreetNumberContainer = styled('div')({});

const StreetNumber = styled(TextField)({
  width: '100px',
  '>div::before': {
    borderBottom: '2px solid #AA9178',
  },
  '>div::after': {
    borderBottom: '2px solid #AA9178',
  },
});

const StreetNameContainer = styled('div')({});

const StreetName = styled(TextField)({
  width: '230px',
  '>div::before': {
    borderBottom: '2px solid #AA9178',
  },
  '>div::after': {
    borderBottom: '2px solid #AA9178',
  },
});

const SuburbContainer = styled('div')({});

const Suburb = styled(TextField)({
  width: '160px',
  '>div::before': {
    borderBottom: '2px solid #AA9178',
  },
  '>div::after': {
    borderBottom: '2px solid #AA9178',
  },
});

const StateContainer = styled('div')({});

const State = styled(TextField)({
  width: '170px',
  '>div::before': {
    borderBottom: '2px solid #AA9178',
  },
  '>div::after': {
    borderBottom: '2px solid #AA9178',
  },
  '& .MuiSelect-select': {
    fontFamily: 'Fjalla One',
    fontWeight: 400,
    fontSize: '18px',
    lineHeight: '22px',
  },
  '& .MuiInput-input': {
    padding: '2px 0 3px 0',
  },
});

const CafeInfo = ({ formik }) => {
  return (
    <CafeInfoContainer>
      <CafeNameContainer>
        <CafeName
          disabled
          name="cafeName"
          label={'Cafe name'}
          variant={'standard'}
          placeholder={'Add your cafe name'}
          InputProps={TextInputProps}
          InputLabelProps={TextInputLabelProps}
          style={TextStyle}
          value={formik.values.cafeName}
          onChange={formik.handleChange}
        />
        {formik.errors.cafeName && formik.touched.cafeName ? (
          <ErrorMessage>please enter your cafe name</ErrorMessage>
        ) : (
          <ErrorMessageEmpty />
        )}
      </CafeNameContainer>
      <FlexContainer>
        <CafePhoneContainer>
          <CafePhone
            name="cafePhone"
            label={'Phone Number'}
            variant={'standard'}
            placeholder={'Leave your cafe number'}
            InputProps={TextInputProps}
            InputLabelProps={TextInputLabelProps}
            style={TextStyle}
            value={formik.values.cafePhone}
            onChange={formik.handleChange}
          />
          {formik.errors.cafePhone && formik.touched.cafePhone ? (
            <ErrorMessage>please enter your cafe contact number</ErrorMessage>
          ) : (
            <ErrorMessageEmpty />
          )}
        </CafePhoneContainer>
        <PostcodeContainer>
          <Postcode
            name="postcode"
            label={'Postcode'}
            variant={'standard'}
            placeholder={'Postcode'}
            InputProps={TextInputProps}
            InputLabelProps={TextInputLabelProps}
            style={TextStyle}
            value={formik.values.postcode}
            onChange={formik.handleChange}
          />
          {formik.errors.postcode && formik.touched.postcode ? (
            <ErrorMessage>required</ErrorMessage>
          ) : (
            <ErrorMessageEmpty />
          )}
        </PostcodeContainer>
      </FlexContainer>
      <FlexContainer>
        <StreetNumberContainer>
          <StreetNumber
            name="streetNumber"
            label={'Street num'}
            variant={'standard'}
            placeholder={'Street num'}
            InputProps={TextInputProps}
            InputLabelProps={TextInputLabelProps}
            style={TextStyle}
            value={formik.values.streetNumber}
            onChange={formik.handleChange}
          />
          {formik.errors.streetNumber && formik.touched.streetNumber ? (
            <ErrorMessage>required</ErrorMessage>
          ) : (
            <ErrorMessageEmpty />
          )}
        </StreetNumberContainer>
        <StreetNameContainer>
          <StreetName
            name="streetName"
            label={'Street name'}
            variant={'standard'}
            placeholder={'Street name'}
            InputProps={TextInputProps}
            InputLabelProps={TextInputLabelProps}
            style={TextStyle}
            value={formik.values.streetName}
            onChange={formik.handleChange}
          />
          {formik.errors.streetName && formik.touched.streetName ? (
            <ErrorMessage>please enter street name</ErrorMessage>
          ) : (
            <ErrorMessageEmpty />
          )}
        </StreetNameContainer>
      </FlexContainer>
      <FlexContainer>
        <SuburbContainer>
          <Suburb
            name="city"
            label={'Suburb'}
            variant={'standard'}
            placeholder={'Suburb'}
            InputProps={TextInputProps}
            InputLabelProps={TextInputLabelProps}
            style={TextStyle}
            value={formik.values.city}
            onChange={formik.handleChange}
          />
          {formik.errors.city && formik.touched.city ? (
            <ErrorMessage>please enter suburb</ErrorMessage>
          ) : (
            <ErrorMessageEmpty />
          )}
        </SuburbContainer>
        <StateContainer>
          <State
            select
            name="state"
            label={'State'}
            variant={'standard'}
            placeholder={'State'}
            InputLabelProps={TextInputLabelProps}
            value={formik.values.state}
            onChange={formik.handleChange}
          >
            <MenuItem style={TextStyle} value={'NSW'}>
              NSW
            </MenuItem>
            <MenuItem style={TextStyle} value={'VIC'}>
              VIC
            </MenuItem>
            <MenuItem style={TextStyle} value={'ACT'}>
              ACT
            </MenuItem>
            <MenuItem style={TextStyle} value={'SA'}>
              SA
            </MenuItem>
            <MenuItem style={{ display: 'none' }} value={''} />
          </State>
          {formik.errors.state && formik.touched.state ? (
            <ErrorMessage>please enter state</ErrorMessage>
          ) : (
            <ErrorMessageEmpty />
          )}
        </StateContainer>
      </FlexContainer>
    </CafeInfoContainer>
  );
};

export default CafeInfo;
